export const ROLES = {
  PARTNER: 'PARTNER',
  OPERADOR_LOGISTICO: 'OPERADOR_LOGISTICO',
  TECNICO: 'TECNICO',
  CLIENTE: 'CLIENTE',
  GESTOR_INSTALACIONES: 'GESTOR_INSTALACIONES',
  ADMIN: 'ADMIN',
} as const;

export type Role = (typeof ROLES)[keyof typeof ROLES];

// El backend serializa /api/users/me por alias (camelCase). Debe coincidir con
// lo que emite FastAPI (response_model_by_alias=True); leerlo en snake_case deja
// los campos en undefined (bug historico enmascarado por los fallbacks de nombre).
export interface UserProfileResponse {
  id: string;
  rut: string;
  nombreCompleto: string;
  /** Solo backoffice (ADMIN, GESTOR_INSTALACIONES): su `/me` manda `nombre` y no `nombreCompleto`. */
  nombre?: string;
  email: string;
  telefono: string;
  codigoPais: string;
  region: string;
  direccion: string;
  numeroDireccion: string;
  comuna: string;
  referenciaDireccion: string | null;
  createdAt: string;
  role: string | null;
}

export interface UserProfile {
  id: string;
  rut: string;
  nombreCompleto: string;
  email: string;
  telefono: string;
  codigoPais: string;
  region: string;
  direccion: string;
  numeroDireccion: string;
  comuna: string;
  referenciaDireccion: string | null;
  createdAt: string;
  role: Role | null;
}
